export default "__VITE_ASSET__D7$j8iet__"